{
  "floating_button": {
    "text": "Ready to Try"
  },
  "header_content": {
    "title": "Try Before You Buy®",
    "subtitle": "Try Up to 4 Carpets for Free in Your Space!",
    "description": "Love it? Keep it, Don’t? We’ll handle the rest."
  },
  "try_bundler_content": {
    "heading": "Add Matching Cushions 🎨",
    "first_description": {
      "first_text": "You can pick ",
      "second_text": {
        "bold_text": "one bundle"
      },
      "third_text": "to try —",
      "fourth_text": {
        "bold_text": "completely free!"
      },
      "fifth_text": "Choose from our curated cushion bundles to match your carpets."
    },
    "left_button_text": "Skip This Step",
    "right_button_text": "See Cushions Options",
    "product_id_text": "Product Id"
  },
  "cushion_recommendations": {
    "title": "Select one cushion bundle to try along with your carpets.",
    "add_for_trial": "Add for trial",
    "continue_without_cushions": "Continue without Cushions"
  },
  "summary": {
    "text_one": "Here’s what you’ve selected so far",
    "text_two": "Selected Carpet",
    "text_three": "Cushion Bundle"
  },
  "schedule": {
    "emirate_text": "Emirate",
    "available_date_text": "Select an Available Date",
    "previous_text": "Previous",
    "next_text": "Next",
    "select_time_text": "Select Time",
    "contact_details_text": "Contact Details",
    "phone_number_text": "Phone No.",
    "country_code_text": "AE (+971)",
    "form": {
      "label": {
        "name": "Name",
        "email": "Email",
        "address": "Address"
      },
      "placeholder": {
        "select": "Select",
        "name": "Enter Name",
        "email": "Enter Email",
        "phone": "Enter Phone no.",
        "address": "Enter Address"
      },
      "error": {
        "went_wrong": "Something went wrong. Please try again.",
        "valid_number": "Enter a valid UAE phone number",
        "incomplete": "Invalid number or incorrect format",
        "invalid": "Invalid UAE phone number"
      }
    }
  },
  "render_description_content": {
    "text_one": "Schedule Your Free Trial Delivery",
    "text_two": "Summary"
  },
  "render_title_content": {
    "text_one": "Review and Confirm"
  },
  "review": {
    "text_one": "Your Selected Carpet",
    "text_two": "Cushion Bundle",
    "text_three": "Date and Time Selected",
    "date_text": "Date",
    "time_text": "Time",
    "contact_details_text": "Your Contact Details",
    "confirm_and_continue": "Confirm & Continue"
  },
  "schedule_free_trial_button_text": "Schedule Your Free Trial",
  "confirm_and_continue_text": "Confirm & Continue",
  "success": {
    "title": "You’re all set!",
    "description": "Once confirmed, we will schedule your trial and send you a confirmation via WhatsApp."
  }
}
